/**
 * Month keys (YYYY-MM) and ISO dates, in UTC so a key never drifts into the
 * neighbouring month. No working-day arithmetic lives in the frontend: a date
 * that must agree with the business's calendar comes from the backend (Time),
 * as the pipeline's curve landing months do.
 */

/** ISO date (YYYY-MM-DD) — the wire format for every date on this surface. */
export function isoDate(d: Date): string {
  return d.toISOString().slice(0, 10);
}

/** Month key (YYYY-MM) for a date. */
export function monthKeyOf(d: Date): string {
  return `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, "0")}`;
}

/** The month key following the given one. */
export function nextMonthKey(monthKey: string): string {
  const [y, m] = monthKey.split("-").map(Number);
  const d = new Date(Date.UTC(y, m, 1));
  return monthKeyOf(d);
}

/** The month key preceding the given one. */
export function previousMonthKey(monthKey: string): string {
  const [y, m] = monthKey.split("-").map(Number);
  return monthKeyOf(new Date(Date.UTC(y, m - 2, 1)));
}

/** Human month label, e.g. "September 2026". */
export function monthLabelOf(monthKey: string): string {
  return new Date(`${monthKey}-01T00:00:00Z`).toLocaleDateString("en-GB", {
    month: "long",
    year: "numeric",
    timeZone: "UTC",
  });
}
